// src/pages/Blogs.jsx
import React, { useState } from "react";
import HeaderSection from "../components/blogs/HeaderSection";
import BlogPreview from "../components/blogs/BlogPreview";
import RecentPosts from "../components/blogs/RecentPosts";
import Footer from "../components/homepage/Footer"

// Import blog images
import colorado14ers from "../assets/blogs/colorado_14ers/b1.jpg";
import modelPhysique from "../assets/blogs/model_physique_without_bulking/b1.jpg";
import nutritionPro from "../assets/blogs/nutrition_for_busy_professionals/b1.jpg";
import strengthLongevity from "../assets/blogs/strength_for_longativity/b1.jpg";

export default function Blogs() {

  const allBlogs = [
    {
      title: "How to Train for Colorado 14ers",
      date: "November 26, 2025",
      preview: "Conquer the Colorado peaks with endurance training, acclimatization tips, and expert gear recommendations...",
      keywords: ["Endurance", "Hiking", "Peaks", "Training", "Outdoor"],
      image: colorado14ers,
      link: "/blog/colorado-14ers",
    },
    {
      title: "How to Build a Model Physique Without Bulking",
      date: "November 26, 2025",
      preview: "Achieve lean muscle definition without traditional bulking cycles using functional training and precise nutrition...",
      keywords: ["Lean Muscle", "Functional Training", "Nutrition", "HIIT", "Aesthetics"],
      image: modelPhysique,
      link: "/blog/model-physique-without-bulking",
    },
    {
      title: "Nutrition for Busy Professionals",
      date: "November 26, 2025",
      preview: "Optimize your diet, save time, and stay energized with easy, nutrient-packed meals for the busy lifestyle...",
      keywords: ["Nutrition", "Healthy Eating", "Quick Meals", "Energy", "Productivity"],
      image: nutritionPro,
      link: "/blog/nutrition-for-professionals",
    },
    {
      title: "Endurance vs Strength for Longevity",
      date: "November 26, 2025",
      preview: "Explore the benefits of endurance and strength training for long-term health, energy, and functional fitness...",
      keywords: ["Endurance", "Strength", "Longevity", "Fitness", "Health"],
      image: strengthLongevity,
      link: "/blog/strength-for-longevity",
    },
  ];

  const [filteredBlogs, setFilteredBlogs] = useState(allBlogs);

  const handleSearch = (term) => {
    const lower = term.toLowerCase();
    setFilteredBlogs(
      allBlogs.filter(
        (b) =>
          b.title.toLowerCase().includes(lower) ||
          b.preview.toLowerCase().includes(lower) ||
          b.keywords.some((k) => k.toLowerCase().includes(lower))
      )
    );
  };

  return (
    <>
    <div className="w-full flex flex-col py-16">

      {/* HEADER FULL WIDTH */}
      <HeaderSection onSearch={handleSearch} />

      {/* TWO-COLUMN LAYOUT */}
      <div className="px-4 md:px-16 py-12 flex gap-10">

        {/* LEFT SIDE → BLOG LIST */}
        <div className="flex-1">
          <BlogPreview blogs={filteredBlogs} />
        </div>

        {/* RIGHT SIDE → FIXED RECENT POSTS */}
        <div className="hidden lg:block w-1/4">
          <div className="sticky top-24">
            <RecentPosts />
          </div>
        </div>

      </div>
    </div>
    <Footer />

    </>
  );
}
